<nav id="menu-services" (keyup.escape)="close()" aria-label="Services Menu">
    <div id="services-header">
        <div id="services-header-icon">
            <img
                width="19"
                height="13"
                [ngSrc]="'assets/images/app-icons/transnetyx-icon.svg'"
                [alt]="'transnetyx' | translate"
                id="transnetyx-icon" />
        </div>
        <p>{{ 'toolbar.servicesPanel.header' | translate }}</p>
    </div>

    <a
        id="genetic-monitoring-link"
        tabindex="0"
        aria-label="Go to Genetic Monitoring"
        (click)="goToGeneticMonitoring(); logAction('genetic-monitoring')"
        (keyup.enter)="goToGeneticMonitoring(); logAction('genetic-monitoring')">
        <div>
            <img
                ngSrc="assets/images/app-icons/genetic-monitoring-icon.svg"
                id="genetic-monitoring-icon"
                height="30"
                width="30" />
            <label for="genetic-monitoring-icon" id="genetic-monitoring-label">{{
                'toolbar.servicesPanel.geneticMonitoring' | translate
            }}</label>
        </div>
        <deco-icon [iconClass]="'fa-regular fa-arrow-up-right-from-square'"></deco-icon>
    </a>

    <a
        id="microbiome-link"
        tabindex="0"
        aria-label="Go to Microbiome"
        (click)="goToMicrobiome(); logAction('microbiome')"
        (keyup.enter)="goToMicrobiome(); logAction('microbiome')">
        <div>
            <img ngSrc="assets/images/app-icons/microbiome-icon.svg" id="microbiome-icon" height="30" width="30" />
            <label for="microbiome-icon" id="microbiome-label">{{
                'toolbar.servicesPanel.microbiome' | translate
            }}</label>
        </div>
        <deco-icon [iconClass]="'fa-regular fa-arrow-up-right-from-square'"></deco-icon>
    </a>

    <a
        id="colony-and-ami-link"
        tabindex="0"
        aria-label="Go to Colony+AMI"
        (click)="goToColony(); logAction('colony')"
        (keyup.enter)="goToColony(); logAction('colony')">
        <div>
            <img ngSrc="assets/images/app-icons/colony-icon.svg" id="colony-and-ami-icon" height="30" width="30" />
            <label for="colony-and-ami-icon" id="colony-and-ami-label">{{
                'toolbar.servicesPanel.colony' | translate
            }}</label>
        </div>
        <deco-icon [iconClass]="'fa-regular fa-arrow-up-right-from-square'"></deco-icon>
    </a>

    <a
        id="tissue-link"
        tabindex="0"
        aria-label="Go to Tissue"
        (click)="goToTissue(); logAction('tissue')"
        (keyup.enter)="goToTissue(); logAction('tissue')">
        <div>
            <img ngSrc="assets/images/app-icons/tissue-icon.svg" id="tissue-icon" height="30" width="30" />
            <label for="tissue-icon" id="tissue-label">{{ 'toolbar.servicesPanel.tissue' | translate }}</label>
        </div>
        <deco-icon [iconClass]="'fa-regular fa-arrow-up-right-from-square'"></deco-icon>
    </a>

    <a
        id="tag-center-link"
        tabindex="0"
        aria-label="Go to TAGCenter"
        (click)="goToTagCenter(); logAction('tag-center')"
        (keyup.enter)="goToTagCenter(); logAction('tag-center')">
        <div>
            <img ngSrc="assets/images/app-icons/tag-center-icon.svg" id="tag-center-icon" height="30" width="30" />
            <label for="tag-center-icon" id="tag-center-label">{{
                'toolbar.servicesPanel.tagCenter' | translate
            }}</label>
        </div>
        <deco-icon [iconClass]="'fa-regular fa-arrow-up-right-from-square'"></deco-icon>
    </a>
</nav>
